// theme-check-disable

(function () {
  "use strict";

  var _original = null;
  var _basePrice = 0;
  var _discountRate = 0;
  var _firstPlanId = "";
  var _variantSubRegistered = false;

  function collectImgs(selector) {
    var imgs = [];
    document.querySelectorAll(selector).forEach(function (img) {
      imgs.push({
        src: img.src,
        alt: img.alt,
        srcset: img.getAttribute("srcset") || "",
        sizes: img.getAttribute("sizes") || "",
      });
    });
    return imgs;
  }

  function applyImgData(img, data) {
    img.src = data.src;
    img.alt = data.alt;
    if (data.srcset) img.setAttribute("srcset", data.srcset);
    if (data.sizes) img.setAttribute("sizes", data.sizes);
  }

  function getPriceEls() {
    return {
      price: document.getElementById("product_price"),
      compare: document.getElementById("product_compare_price"),
      dawn: document.querySelector(
        ".price__regular .price-item--regular:not(.variant-item__old-price):not(s)",
      ),
      sale: document.querySelector(
        ".price__sale .price-item--sale.price-item--last",
      ),
    };
  }

  function setPriceText(els, text) {
    if (els.price) els.price.innerText = text;
    if (els.dawn) els.dawn.innerText = text;
    if (els.sale) els.sale.innerText = text;
  }

  function getWidget() {
    return document.querySelector("[data-subscription-widget]");
  }

  function resetCtmSwipers(mainSlider, thumbSlider) {
    if (mainSlider && mainSlider.swiper) {
      mainSlider.swiper.update();
      mainSlider.swiper.slideTo(0, 0);
    }
    if (thumbSlider && thumbSlider.swiper) {
      thumbSlider.swiper.update();
      thumbSlider.swiper.slideTo(0, 0);
      if (typeof setCtmThumbActive === "function") {
        setCtmThumbActive(thumbSlider, 0);
      }
    }
  }

  function getCtmSliders() {
    return {
      main: document.querySelector(".ctm_pdp_mainproduct_slider"),
      thumb: document.querySelector(".ctm_pdp_mainproduct_thumbnail_slider"),
    };
  }

  function isBundleActive() {
    return !!document.querySelector("[data-bundle-option].active");
  }

  function saveOriginalProduct() {
    if (_original) return;
    // Never capture bundle state as "original" — bail if a bundle is already active.
    if (isBundleActive()) return;

    var titleEl = document.querySelector(
      ".product__title h1, .product_title .pro_title",
    );
    var priceEl =
      document.getElementById("product_price") ||
      document.querySelector(
        ".price__regular .price-item--regular:not(.variant-item__old-price)",
      );
    var descEl = document.querySelector(
      ".product__description, .product-description",
    );
    var variantEl = document.querySelector("[data-main-variant-id]");
    var btnSpan = document.querySelector(".product-form__submit-price");
    var widget = getWidget();

    _original = {
      title: titleEl ? titleEl.innerText.trim() : "",
      price: priceEl ? priceEl.innerText.trim() : "",
      desc: descEl ? descEl.innerHTML : "",
      variantId: variantEl ? variantEl.dataset.mainVariantId : "",
      images: collectImgs(".product__media-item .product__media img"),
      thumbImages: collectImgs(".thumbnail-list__item .thumbnail img"),
      ctmImages: collectImgs(
        ".ctm_pdp_mainproduct_slider .swiper-slide .product__media img",
      ),
      ctmThumbImages: collectImgs(
        ".ctm_pdp_mainproduct_thumbnail_slider .ctm-pdp-thumb-slide .product__media img",
      ),
      buttonPriceHTML: btnSpan ? btnSpan.innerHTML : null,
      buttonPriceHidden: btnSpan ? btnSpan.classList.contains("hidden") : true,
      // Saved so syncWidgetState() after deselect reads original product values, not stale bundle values.
      widgetPrice: widget ? widget.dataset.price : "",
      widgetDiscount: widget ? widget.dataset.discount : "",
      widgetFirstPlanId: widget ? widget.dataset.firstPlanId : "",
    };
  }

  function restoreOriginalProduct() {
    if (!_original) return;

    updateProductTitle(_original.title);

    var els = getPriceEls();
    if (els.price) els.price.innerText = _original.price;
    if (els.dawn && _original.price) els.dawn.innerText = _original.price;
    if (els.sale && _original.price) els.sale.innerText = _original.price;
    if (els.compare) els.compare.innerText = "";

    var btnSpan = document.querySelector(".product-form__submit-price");
    if (btnSpan && _original.buttonPriceHTML !== null) {
      btnSpan.innerHTML = _original.buttonPriceHTML;
      btnSpan.classList.toggle("hidden", _original.buttonPriceHidden);
    }

    var descEl = document.querySelector(
      ".product__description, .product-description",
    );
    if (descEl && _original.desc) descEl.innerHTML = _original.desc;

    document.querySelectorAll('form [name="id"]').forEach(function (input) {
      input.value = _original.variantId;
    });

    var widget = getWidget();
    if (widget && _original.widgetPrice !== undefined) {
      widget.dataset.price = _original.widgetPrice;
      widget.dataset.discount = _original.widgetDiscount;
      if (_original.widgetFirstPlanId) {
        widget.dataset.firstPlanId = _original.widgetFirstPlanId;
      }
    }

    restoreOriginalImages(_original.images);
    restoreCtmImages(_original.ctmImages, _original.ctmThumbImages);
  }

  function updateProductTitle(title) {
    var dawnTitle = document.querySelector(".product__title h1");
    if (dawnTitle) dawnTitle.innerText = title;

    var legacyTitle = document.querySelector(".product_title .pro_title");
    if (legacyTitle) legacyTitle.innerText = title;

    var stickyTitle = document.querySelector(".pdp_sticky_bar_left p");
    if (stickyTitle) stickyTitle.innerHTML = title;

    document.title =
      title +
      " – " +
      (window.Shopify && window.Shopify.shop ? window.Shopify.shop : "");
  }

  function updateProductDescription(html) {
    var el =
      document.querySelector(".product__description") ||
      document.querySelector(".product-description");
    if (el) el.innerHTML = html;
  }

  function formatMoney(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents);
    }
    return (cents / 100).toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
    });
  }

  function updateButtonPrice(formattedPrice) {
    var span = document.querySelector(".product-form__submit-price");
    if (!span) return;
    span.innerHTML = " — " + formattedPrice;
    span.classList.remove("hidden");
  }

  function updatePriceDisplay(isSubscribed, basePriceCents, discountRate) {
    var fmtOriginal = formatMoney(basePriceCents);
    var discountedCents = Math.round(
      basePriceCents - basePriceCents * discountRate,
    );
    var fmtDiscounted = formatMoney(discountedCents);

    updateButtonPrice(isSubscribed ? fmtDiscounted : fmtOriginal);

    // Refresh widget inline text — server-rendered by Liquid, stale after Dawn section re-renders.
    var widget = getWidget();
    if (widget) {
      var oneTimeEl = widget.querySelector("[data-onetime-price]");
      var origEl = widget.querySelector("[data-sub-original-price]");
      var discEl = widget.querySelector("[data-discounted-price]");
      if (oneTimeEl) oneTimeEl.innerText = fmtOriginal;
      if (origEl) origEl.innerText = fmtOriginal;
      if (discEl) discEl.innerText = fmtDiscounted;
    }

    var els = getPriceEls();
    if (!els.price && !els.dawn && !els.sale) return;

    if (!isSubscribed) {
      setPriceText(els, fmtOriginal);
      if (els.compare) els.compare.innerText = "";
      return;
    }

    setPriceText(els, fmtDiscounted);
    if (els.compare && basePriceCents > discountedCents) {
      els.compare.innerText = fmtOriginal;
    }

    document.querySelectorAll(".price-el").forEach(function (el) {
      var match = el.innerHTML.match(/\$[\d,]+(\.\d{1,2})?/);
      if (match) el.innerHTML = el.innerHTML.replace(match[0], fmtDiscounted);
    });
  }

  function updateVariantOptionPrices(isSubscribed) {
    var discountRate = isSubscribed ? _discountRate : 0;
    document.querySelectorAll("[data-variant-price]").forEach(function (span) {
      var basePrice = parseInt(span.dataset.basePrice || 0, 10);
      if (!basePrice) return;
      span.textContent = formatMoney(
        Math.round(basePrice - basePrice * discountRate),
      );
    });
  }

  function setBundlePrice(priceFormatted) {
    var els = getPriceEls();
    setPriceText(els, priceFormatted);
    if (els.compare) els.compare.innerText = "";
    updateButtonPrice(priceFormatted);
  }

  function updateProductImages(images, altText) {
    if (!images || !images.length) return;

    var firstImage = images[0];
    var mediaContainer = document.querySelector(".product__media-list");
    var thumbContainer = document.querySelector(".thumbnail-list");
    if (!mediaContainer || !thumbContainer) return;

    var mediaItems = mediaContainer.querySelectorAll(".product__media-item");
    while (mediaItems.length < images.length) {
      mediaContainer.appendChild(mediaItems[0].cloneNode(true));
      mediaItems = mediaContainer.querySelectorAll(".product__media-item");
    }

    var thumbItems = thumbContainer.querySelectorAll(".thumbnail-list__item");
    while (thumbItems.length < images.length) {
      thumbContainer.appendChild(thumbItems[0].cloneNode(true));
      thumbItems = thumbContainer.querySelectorAll(".thumbnail-list__item");
    }

    mediaItems.forEach(function (item, i) {
      var img = item.querySelector("img");
      if (!img) return;
      img.src = images[i] || firstImage;
      img.removeAttribute("srcset");
      img.removeAttribute("sizes");
      if (altText) img.alt = altText;
      item.style.display = i === 0 ? "" : "none";
      item.classList.toggle("is-active", i === 0);
    });

    thumbItems.forEach(function (item, i) {
      var img = item.querySelector(".thumbnail img");
      if (!img) return;
      img.src = images[i] || firstImage;
      img.removeAttribute("srcset");
      img.removeAttribute("sizes");
      if (altText) img.alt = altText + " - image " + (i + 1);
      item.style.display = i < images.length ? "" : "none";
    });

    var stickyImage = document.querySelector(".pdp_sticky_bar_left img");
    if (stickyImage) stickyImage.src = firstImage;

    setTimeout(function () {
      mediaItems = mediaContainer.querySelectorAll(".product__media-item");
      thumbItems = thumbContainer.querySelectorAll(".thumbnail-list__item");

      thumbItems.forEach(function (thumb, index) {
        var button = thumb.querySelector(".thumbnail");
        if (!button) return;

        button.removeAttribute("aria-current");
        button.onclick = function (e) {
          e.preventDefault();
          mediaItems.forEach(function (item, itemIndex) {
            item.style.display = itemIndex === index ? "" : "none";
            item.classList.toggle("is-active", itemIndex === index);
          });
          thumbItems.forEach(function (t) {
            var b = t.querySelector(".thumbnail");
            if (b) b.removeAttribute("aria-current");
          });
          button.setAttribute("aria-current", "true");
          return false;
        };

        if (index === 0) button.setAttribute("aria-current", "true");
      });
    }, 100);
  }

  function restoreOriginalImages(savedImages) {
    if (!savedImages || !savedImages.length) return;

    var galleryImgs = document.querySelectorAll(
      ".product__media-item .product__media img",
    );
    savedImages.forEach(function (item, i) {
      if (galleryImgs[i]) applyImgData(galleryImgs[i], item);
    });

    if (_original && _original.thumbImages && _original.thumbImages.length) {
      var thumbEls = document.querySelectorAll(
        ".thumbnail-list__item .thumbnail img",
      );
      _original.thumbImages.forEach(function (item, i) {
        if (thumbEls[i]) applyImgData(thumbEls[i], item);
      });
    }

    var mediaGallery = document.querySelector("media-gallery");
    var firstMediaItem = document.querySelector(
      '[id^="GalleryViewer"] [data-media-id]',
    );
    if (
      mediaGallery &&
      firstMediaItem &&
      typeof mediaGallery.setActiveMedia === "function"
    ) {
      try {
        mediaGallery.setActiveMedia(firstMediaItem.dataset.mediaId, false);
      } catch (e) {}
    }
  }

  function updateCtmImages(images, altText) {
    if (!images || !images.length) return;

    var sliders = getCtmSliders();
    if (!sliders.main) return;

    var firstImage = images[0];

    sliders.main.querySelectorAll(".swiper-slide").forEach(function (slide, i) {
      var img = slide.querySelector(".product__media img");
      if (!img) return;
      img.src = images[i] || firstImage;
      img.removeAttribute("srcset");
      img.removeAttribute("sizes");
      if (altText) img.alt = altText;
      slide.style.display = i < images.length ? "" : "none";
    });

    if (sliders.thumb) {
      sliders.thumb
        .querySelectorAll(".ctm-pdp-thumb-slide")
        .forEach(function (slide, i) {
          var img = slide.querySelector(".product__media img");
          if (!img) return;
          img.src = images[i] || firstImage;
          img.removeAttribute("srcset");
          img.removeAttribute("sizes");
          if (altText) img.alt = altText;
          slide.style.display = i < images.length ? "" : "none";
        });
    }

    resetCtmSwipers(sliders.main, sliders.thumb);
  }

  function restoreCtmImages(savedImages, savedThumbImages) {
    var sliders = getCtmSliders();
    if (!sliders.main) return;

    if (savedImages && savedImages.length) {
      var mainSlides = sliders.main.querySelectorAll(".swiper-slide");
      savedImages.forEach(function (item, i) {
        var slide = mainSlides[i];
        if (!slide) return;
        var img = slide.querySelector(".product__media img");
        if (img) {
          applyImgData(img, item);
          slide.style.display = "";
        }
      });
    }

    if (sliders.thumb && savedThumbImages && savedThumbImages.length) {
      var thumbSlides = sliders.thumb.querySelectorAll(".ctm-pdp-thumb-slide");
      savedThumbImages.forEach(function (item, i) {
        var slide = thumbSlides[i];
        if (!slide) return;
        var img = slide.querySelector(".product__media img");
        if (img) {
          applyImgData(img, item);
          slide.style.display = "";
        }
      });
    }

    resetCtmSwipers(sliders.main, sliders.thumb);
  }

  function updateOptionStyles(widget) {
    var checkedRadio = widget.querySelector(
      "[data-subscription-radio]:checked",
    );
    widget.querySelectorAll("[data-sub-option]").forEach(function (opt) {
      opt.classList.toggle(
        "is-selected",
        !!(checkedRadio && opt.dataset.subOption === checkedRadio.value),
      );
    });
  }

  function hideSubscription() {
    var widget = getWidget();
    if (!widget) return;

    var oneTimeRadio = widget.querySelector(
      '[data-subscription-radio="one_time"]',
    );
    var subscribeRadio = widget.querySelector(
      '[data-subscription-radio="subscription"]',
    );
    var freqSection = widget.querySelector("[data-subscription-freq]");
    var benefitsSection = widget.querySelector("[data-subscription-benefits]");
    var sellingPlanInput = widget.querySelector("[data-selling-plan-input]");

    if (oneTimeRadio) oneTimeRadio.checked = true;
    if (subscribeRadio) subscribeRadio.checked = false;
    if (freqSection) freqSection.style.display = "none";
    if (benefitsSection) benefitsSection.style.display = "none";
    if (sellingPlanInput) sellingPlanInput.value = "";
    updateOptionStyles(widget);

    widget.style.transition = "opacity 0.25s ease, max-height 0.3s ease";
    widget.style.opacity = "0";
    widget.style.overflow = "hidden";
    widget.style.maxHeight = widget.offsetHeight + "px";
    setTimeout(function () {
      widget.style.maxHeight = "0";
    }, 10);
    setTimeout(function () {
      widget.style.display = "none";
      widget.style.maxHeight = "";
      widget.style.overflow = "";
    }, 320);
  }

  function showSubscription() {
    var widget = getWidget();
    if (!widget) return;

    widget.style.display = "";
    widget.style.opacity = "0";
    widget.style.overflow = "hidden";
    widget.style.maxHeight = "0";
    widget.style.transition = "opacity 0.25s ease, max-height 0.3s ease";
    setTimeout(function () {
      widget.style.maxHeight = "600px";
      widget.style.opacity = "1";
    }, 10);
    setTimeout(function () {
      widget.style.maxHeight = "";
      widget.style.overflow = "";
    }, 320);
  }

  function resetSubscription(newPriceCents, newDiscountRate, newFirstPlanId) {
    var widget = getWidget();
    if (!widget) return;
    widget.dataset.price = newPriceCents;
    widget.dataset.discount = newDiscountRate;
    if (newFirstPlanId) widget.dataset.firstPlanId = newFirstPlanId;
    _basePrice = newPriceCents;
    _discountRate = parseFloat(newDiscountRate) / 100;
    if (newFirstPlanId) _firstPlanId = newFirstPlanId;
  }

  function selectBundle(selectedOption) {
    var isAlreadyActive = selectedOption.classList.contains("active");

    if (isAlreadyActive) {
      selectedOption.classList.remove("active");
      selectedOption.setAttribute("aria-pressed", "false");
      restoreOriginalProduct();
      showSubscription();
      syncWidgetState();
      reconcileButtonPrice();
      var variantPicker = document.querySelector(
        "variant-selects, variant-radios",
      );
      if (variantPicker) variantPicker.style.display = "";
      document.dispatchEvent(
        new CustomEvent("bundle:deselected", { bubbles: true }),
      );
      return;
    }

    var variantId = selectedOption.dataset.variantId;
    var price = parseInt(selectedOption.dataset.price || 0, 10);
    var priceFormatted = selectedOption.dataset.priceFormatted;
    var title = selectedOption.dataset.title;
    var description = selectedOption.dataset.description;
    var imagesJson = selectedOption.dataset.images;
    var discountRate = parseFloat(
      selectedOption.dataset.sellingPlanDiscount || 0,
    );
    var firstPlanId = selectedOption.dataset.sellingPlanId || "";
    var handle = selectedOption.dataset.handle;

    saveOriginalProduct();

    document.querySelectorAll("[data-bundle-option]").forEach(function (opt) {
      opt.classList.remove("active");
      opt.setAttribute("aria-pressed", "false");
    });
    selectedOption.classList.add("active");
    selectedOption.setAttribute("aria-pressed", "true");

    document.querySelectorAll('form [name="id"]').forEach(function (input) {
      input.value = variantId;
    });

    updateProductTitle(title);
    setBundlePrice(priceFormatted);
    if (description) updateProductDescription(description);

    if (imagesJson) {
      try {
        var parsedImages = JSON.parse(imagesJson);
        updateProductImages(parsedImages, title);
        updateCtmImages(parsedImages, title);
      } catch (e) {}
    }

    resetSubscription(price, discountRate, firstPlanId);
    hideSubscription();

    var variantPicker = document.querySelector(
      "variant-selects, variant-radios",
    );
    if (variantPicker) variantPicker.style.display = "none";

    document.dispatchEvent(
      new CustomEvent("bundle:selected", {
        bubbles: true,
        detail: { variantId: variantId, handle: handle, price: price },
      }),
    );
  }

  function syncWidgetState() {
    var widget = getWidget();
    if (!widget) return;
    _basePrice = parseInt(widget.dataset.price || 0, 10);
    _discountRate = parseFloat(widget.dataset.discount || 0) / 100;
    _firstPlanId = widget.dataset.firstPlanId || "";
  }

  function initWidgetDisplay() {
    var widget = getWidget();
    if (!widget) return;
    var freqSection = widget.querySelector("[data-subscription-freq]");
    var benefitsSection = widget.querySelector("[data-subscription-benefits]");
    if (freqSection) freqSection.style.display = "none";
    if (benefitsSection) benefitsSection.style.display = "none";
    updateOptionStyles(widget);
  }

  function reconcileButtonPrice() {
    if (isBundleActive()) return;
    if (!_basePrice) return;
    var widget = getWidget();
    var subscribeRadio = widget
      ? widget.querySelector('[data-subscription-radio="subscription"]')
      : null;
    var isSubscribed = !!(subscribeRadio && subscribeRadio.checked);
    // Always call updatePriceDisplay so button, main price elements, and widget
    // inline text nodes are all refreshed from _basePrice in one pass.
    updatePriceDisplay(isSubscribed, _basePrice, _discountRate);
    updateVariantOptionPrices(isSubscribed);
  }

  // Attached on document — survives Dawn section re-renders after ATC.
  document.addEventListener("change", function (e) {
    if (!e.target.hasAttribute("data-subscription-radio")) return;
    if (isBundleActive()) return;

    var radio = e.target;
    var widget = getWidget();
    if (!widget) return;

    var freqSection = widget.querySelector("[data-subscription-freq]");
    var benefitsSection = widget.querySelector("[data-subscription-benefits]");
    var sellingPlanInput = widget.querySelector("[data-selling-plan-input]");

    if (radio.value === "subscription") {
      if (freqSection) freqSection.style.display = "flex";
      if (benefitsSection) benefitsSection.style.display = "block";
      var activeBtn = widget.querySelector(
        "[data-subscription-freq-btn].is-active",
      );
      if (sellingPlanInput) {
        sellingPlanInput.value = activeBtn
          ? activeBtn.dataset.planId
          : _firstPlanId;
      }
      updatePriceDisplay(true, _basePrice, _discountRate);
      updateVariantOptionPrices(true);
    } else {
      if (freqSection) freqSection.style.display = "none";
      if (benefitsSection) benefitsSection.style.display = "none";
      if (sellingPlanInput) sellingPlanInput.value = "";
      updatePriceDisplay(false, _basePrice, _discountRate);
      updateVariantOptionPrices(false);
    }
    updateOptionStyles(widget);
  });

  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-subscription-freq-btn]");
    if (!btn) return;
    if (isBundleActive()) return;
    var widget = getWidget();
    if (!widget) return;

    widget
      .querySelectorAll("[data-subscription-freq-btn]")
      .forEach(function (b) {
        b.classList.remove("is-active");
        b.setAttribute("aria-current", "false");
      });
    btn.classList.add("is-active");
    btn.setAttribute("aria-current", "true");
    var sellingPlanInput = widget.querySelector("[data-selling-plan-input]");
    if (sellingPlanInput) sellingPlanInput.value = btn.dataset.planId;
  });

  document.addEventListener("click", function (e) {
    var option = e.target.closest("[data-bundle-option]");
    if (!option) return;
    selectBundle(option);
  });

  document.addEventListener("keydown", function (e) {
    if (e.key !== "Enter" && e.key !== " ") return;
    var option = e.target.closest("[data-bundle-option]");
    if (!option) return;
    e.preventDefault();
    selectBundle(option);
  });

  // Registered once — guard prevents duplicates on pageshow re-init.
  function setupVariantListener() {
    if (_variantSubRegistered || typeof subscribe !== "function") return;
    _variantSubRegistered = true;

    // Dawn's pub/sub fires 'variant-change' AFTER product-info.js has updated price HTML.
    subscribe("variant-change", function (event) {
      if (isBundleActive()) return;
      var variant = event && event.data && event.data.variant;
      if (!variant || !variant.price) return;

      var newPriceCents = variant.price;
      _basePrice = newPriceCents;
      // Clear _original so the next bundle selection re-captures this variant's
      // prices, not those of a previously selected variant.
      _original = null;

      var widget = getWidget();
      if (widget) widget.dataset.price = newPriceCents;

      var subscribeRadio = widget
        ? widget.querySelector('[data-subscription-radio="subscription"]')
        : null;
      var isSubscribed = !!(subscribeRadio && subscribeRadio.checked);
      updatePriceDisplay(isSubscribed, newPriceCents, _discountRate);
      updateVariantOptionPrices(isSubscribed);
    });
  }

  // Re-syncs state after Dawn section re-renders (post-ATC cart drawer update).
  function watchSectionRerenders() {
    var target =
      document.querySelector(".product__info-wrapper") ||
      document.querySelector(".shopify-section--main-product") ||
      document.getElementById("MainContent");
    if (!target) return;

    new MutationObserver(function (mutations) {
      var widgetAdded = mutations.some(function (m) {
        return Array.from(m.addedNodes).some(function (node) {
          return (
            node.nodeType === 1 &&
            (node.matches("[data-subscription-widget]") ||
              (node.querySelector &&
                node.querySelector("[data-subscription-widget]")))
          );
        });
      });
      if (!widgetAdded) return;

      var widget = getWidget();
      if (_original && !isBundleActive() && _original.widgetPrice) {
        if (widget) {
          widget.dataset.price = _original.widgetPrice;
          widget.dataset.discount =
            _original.widgetDiscount || widget.dataset.discount;
          if (_original.widgetFirstPlanId) {
            widget.dataset.firstPlanId = _original.widgetFirstPlanId;
          }
        }
        _basePrice = parseInt(_original.widgetPrice, 10) || 0;
        _discountRate = parseFloat(_original.widgetDiscount || 0) / 100;
        if (_original.widgetFirstPlanId)
          _firstPlanId = _original.widgetFirstPlanId;
        _original = null;
      } else if (_basePrice && widget) {
        // Normal re-render: write our authoritative state back to prevent the
        // server-rendered default-variant prices from overwriting _basePrice.
        widget.dataset.price = _basePrice;
        widget.dataset.discount = Math.round(_discountRate * 100);
        if (_firstPlanId) widget.dataset.firstPlanId = _firstPlanId;
      } else {
        syncWidgetState();
      }

      initWidgetDisplay();
      reconcileButtonPrice();
    }).observe(target, { childList: true, subtree: true });
  }
  function autoSelectFromUrl() {
    // Only activate on the Online Store. The Buy Button channel embeds the
    // storefront in an iframe — skip in that context.
    if (window.self !== window.top) return;

    var params = new URLSearchParams(window.location.search);
    var subParam = params.get("subscription");
    var sellingPlanParam = params.get("selling_plan");

    if (subParam === null && sellingPlanParam === null) return;

    var widget = getWidget();
    if (!widget) return;

    var subscribeRadio = widget.querySelector(
      '[data-subscription-radio="subscription"]',
    );
    var oneTimeRadio = widget.querySelector(
      '[data-subscription-radio="one_time"]',
    );
    if (!subscribeRadio) return;

    if (oneTimeRadio) oneTimeRadio.checked = false;
    subscribeRadio.checked = true;
    subscribeRadio.dispatchEvent(new Event("change", { bubbles: true }));

    // Named frequency params map to the nth frequency button (0-indexed).
    var freqIndexMap = { one: 0, two: 1, three: 2 };
    var freqBtns = widget.querySelectorAll("[data-subscription-freq-btn]");

    if (
      subParam !== null &&
      subParam !== "monthly" &&
      Object.prototype.hasOwnProperty.call(freqIndexMap, subParam)
    ) {
      var btn = freqBtns[freqIndexMap[subParam]];
      if (btn) btn.click();
    } else if (sellingPlanParam) {
      var btn = widget.querySelector(
        '[data-subscription-freq-btn][data-plan-id="' + sellingPlanParam + '"]',
      );
      if (btn) btn.click();
    }
  }

  function boot() {
    syncWidgetState();
    // Seed _basePrice from ATC button when no subscription widget is present,
    // so reconcileButtonPrice() works correctly after bundle deselect.
    if (!_basePrice) {
      var btnSpan = document.querySelector(".product-form__submit-price");
      if (btnSpan && btnSpan.dataset.basePrice) {
        _basePrice = parseInt(btnSpan.dataset.basePrice, 10) || 0;
      }
    }
    initWidgetDisplay();
    setupVariantListener();
    watchSectionRerenders();
    autoSelectFromUrl();
  }

  // bfcache skips DOMContentLoaded — re-sync so widget state and button price are correct.
  window.addEventListener("pageshow", function (e) {
    if (e.persisted) {
      // Only null _original when no bundle is active; nulling mid-bundle would
      // make saveOriginalProduct() capture bundle state as the restore target.
      if (!isBundleActive()) {
        _original = null;
      }
      syncWidgetState();
      initWidgetDisplay();
      reconcileButtonPrice();
    }
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
